module.exports = __webpack_public_path__ + "img/logo-evision.261d5e2d.png";